import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=21f0a54e&scoped=true&"
import script from "./Printer.vue?vue&type=script&lang=js&"
export * from "./Printer.vue?vue&type=script&lang=js&"
import style0 from "./Printer.vue?vue&type=style&index=0&id=21f0a54e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0a54e",
  null
  
)

export default component.exports